var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVehicles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "veh\\xEDculos_main",
    "data-name": "veh\\xEDculos main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 34,
    height: 34,
    transform: "translate(767 744)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 27.2,
    height: 26.627,
    fill: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_21",
    "data-name": "Mask Group 21",
    transform: "translate(-767 -744)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(770.4 747.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M24.881,11.013v-.043H27.2V4.982H24.881l0-.874c0-.639,0-1.279-.007-1.918A2.123,2.123,0,0,0,22.646,0C16.408,0,10.317,0,4.54,0A2.111,2.111,0,0,0,2.329,2.174c0,.394,0,.789,0,1.183V4.99H0V10.98H2.319l.008,8.19q0,.371,0,.742c0,.5,0,1,0,1.505a2.139,2.139,0,0,0,2.213,2.146h.146v.3c0,.42,0,.826,0,1.233A1.492,1.492,0,0,0,6.235,26.62c.421.005.848.008,1.29.008.408,0,.829,0,1.266-.006a1.516,1.516,0,0,0,1.571-1.539c.006-.353,0-.706,0-1.06,0-.147,0-.293,0-.44h6.47v.253c0,.4,0,.784,0,1.172a1.521,1.521,0,0,0,1.643,1.615c.73,0,1.459,0,2.189,0H20.8a1.521,1.521,0,0,0,1.706-1.659c0-.374,0-.749,0-1.127v-.27a2.207,2.207,0,0,0,1.634-.554,2.394,2.394,0,0,0,.74-1.838c-.024-2.413-.017-4.867-.01-7.241q0-1.461.007-2.921M24.9,9.627V6.314h.932V9.627Zm-3.754,14.5c0,.317,0,.634,0,.95,0,.206-.082.206-.172.207-.831.009-1.68.009-2.595,0-.149,0-.171-.078-.173-.152-.009-.426-.007-.847-.005-1.291q0-.133,0-.266h2.947ZM8.987,25.169c0,.031,0,.115-.15.116-1.059.007-1.868.007-2.624,0-.1,0-.153-.028-.155-.163-.007-.421-.006-.843,0-1.275v-.265h2.94l0,.261c0,.457.006.889-.009,1.328M23.508,17.92q0,1.687,0,3.373c0,.646-.291.934-.943.935H4.633c-.642,0-.941-.289-.941-.908q0-2.245,0-4.491V15.156H23.508ZM3.721,5.176h9.172v8.6H3.721Zm10.587.011h9.18v8.591h-9.18Zm8.27-3.853c.641,0,.928.283.93.917q0,.411,0,.823v.738H3.695q0-.178,0-.355c0-.49-.008-.953.009-1.421a.748.748,0,0,1,.743-.7c.055,0,.11,0,.18,0H22.579M2.3,9.635H1.367v-3.3H2.3Z",
    transform: "translate(0 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M30.631,91.858h.018a2.239,2.239,0,0,0,2.259-2.177,2.143,2.143,0,0,0-.646-1.553,2.27,2.27,0,0,0-1.6-.668h-.015a2.225,2.225,0,0,0-2.24,2.17,2.168,2.168,0,0,0,.641,1.575,2.241,2.241,0,0,0,1.577.653m-.858-2.189a.854.854,0,0,1,.262-.62.89.89,0,0,1,.625-.254h.007a.884.884,0,0,1,.618.261.847.847,0,0,1,.257.61.884.884,0,0,1-.886.863h0a.873.873,0,0,1-.879-.86",
    transform: "translate(-22.937 -70.986)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M91.612,91.857h.051a2.256,2.256,0,0,0,1.554-.608,2.163,2.163,0,0,0,.688-1.547A2.229,2.229,0,0,0,91.7,87.46a2.266,2.266,0,0,0-1.594.622,2.167,2.167,0,0,0-.693,1.555,2.228,2.228,0,0,0,2.2,2.22m.04-1.328a.867.867,0,1,1,.013-1.734h0a.878.878,0,0,1,.614.252.846.846,0,0,1,.263.608h0a.863.863,0,0,1-.267.625.878.878,0,0,1-.628.248",
    transform: "translate(-72.181 -70.985)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 5.245,
    height: 1.314,
    transform: "translate(10.977 18.023)",
    fill: "#707070"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehicles);
export default __webpack_public_path__ + "static/media/icon_vehicles.e30f142ac10783700b5c1d7885937dba.svg";
export { ForwardRef as ReactComponent };